import React from 'react';
import { Link } from 'react-router-dom';
import { Factory, Store, Building2 } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const B2BSection = () => {
  const { t, path } = useLanguage();
  const icons = [Factory, Store, Building2];
  const cards = t('b2b.cards').map((c, i) => ({ ...c, icon: icons[i] }));

  const sectionStyle = {
    padding: '5rem 1.5rem',
    backgroundColor: 'rgba(26, 26, 26, 0.8)',
    position: 'relative'
  };

  const containerStyle = {
    maxWidth: '72rem',
    margin: '0 auto'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '3.5rem'
  };

  const titleStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '1.5rem'
  };

  const highlightStyle = {
    color: '#dfa926'
  };

  const descriptionStyle = {
    fontSize: '1.125rem',
    color: '#d1d5db',
    maxWidth: '48rem',
    margin: '0 auto',
    lineHeight: '1.6'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '2rem',
    marginBottom: '3rem'
  };

  const cardStyle = {
    background: 'linear-gradient(135deg, rgba(26, 26, 26, 0.5) 0%, rgba(17, 17, 17, 0.5) 100%)',
    padding: '2rem',
    borderRadius: '0.75rem',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(58, 58, 58, 0.5)',
    transition: 'all 0.3s ease',
    textAlign: 'left'
  };

  const iconStyle = {
    width: '2.5rem',
    height: '2.5rem',
    color: '#dfa926',
    marginBottom: '1.25rem'
  };

  const cardTitleStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: 'white',
    marginBottom: '0.75rem'
  };

  const cardDescStyle = {
    color: '#9ca3af',
    lineHeight: '1.6',
    margin: 0
  };

  const ctaStyle = {
    display: 'inline-block',
    backgroundColor: '#dfa926',
    color: 'black',
    fontWeight: '600',
    padding: '1rem 2.5rem',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    transition: 'all 0.3s'
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>
            {t('b2b.titlePre')} <span style={highlightStyle}>{t('b2b.titleHl')}</span>
          </h2>
          <p style={descriptionStyle}>{t('b2b.desc')}</p>
        </div>

        <div style={gridStyle}>
          {cards.map((card, i) => {
            const IconComponent = card.icon;
            return (
              <div
                key={i}
                style={cardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(223, 169, 38, 0.5)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(58, 58, 58, 0.5)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <IconComponent style={iconStyle} />
                <h3 style={cardTitleStyle}>{card.title}</h3>
                <p style={cardDescStyle}>{card.desc}</p>
              </div>
            );
          })}
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link
            to={path('/contact')}
            style={ctaStyle}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#c8941f';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#dfa926';
            }}
          >
            {t('b2b.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default B2BSection;
